import { useState } from 'react';
import { all } from '@/api/doc/entity-type';
import { DataTable } from '@/components/ui/custom/data-table';
import { TablePagination } from '@/components/ui/custom/table-pagination';
import { useQuery } from '@tanstack/react-query';
import {
	ColumnFiltersState,
	getCoreRowModel,
	getFilteredRowModel,
	getPaginationRowModel,
	getSortedRowModel,
	SortingState,
	useReactTable,
	VisibilityState,
} from '@tanstack/react-table';

import { columns } from './columns';

export function EntityTypeTable() {
	const { data, isFetching } = useQuery({
		queryFn: () =>
			all({
				includeDeleted: true,
			}),
		queryKey: ['entity-types'],
	});
	const [sorting, setSorting] = useState<SortingState>([]);
	const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
	const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
	const [rowSelection, setRowSelection] = useState({});

	const table = useReactTable({
		data: data ?? [],
		columns: columns,
		onSortingChange: setSorting,
		onColumnFiltersChange: setColumnFilters,
		getCoreRowModel: getCoreRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		onColumnVisibilityChange: setColumnVisibility,
		onRowSelectionChange: setRowSelection,
		state: {
			sorting,
			columnFilters,
			columnVisibility,
			rowSelection,
		},
	});

	return (
		<div className="h-1/2 w-full">
			<DataTable
				table={table}
				isFetching={isFetching}
				noResultsMessage="No entity types found."
			/>

			<TablePagination table={table} isFetching={isFetching} />
		</div>
	);
}
